export const pathData = `
    M2851.77 465.686L2844.13 441.959C2843.37 439.597 2840.92 438.169
    2838.52 438.788C2830.32 440.912 2823.4 441.655 2816.47
    441.655C2788.2 441.655 2777.09 424.448 2777.09
    390.025V176.417C2777.09 27.6017 2681.17 1.28461 2567.06
    1.28461C2419.63 1.28461 2359.05 61.0099 2359.05 123.778C2359.05
    158.201 2380.25 198.691 2432.76 198.691C2482.24 198.691 2509.5
    165.283 2509.5 134.908C2509.5 112.639 2496.37 103.529 2496.37
    88.3461C2496.37 63.0387 2521.62 48.861 2559.99 48.861C2616.54
    48.861 2638.75 79.2309 2638.75 151.11V214.893C2435.79 224.003
    2330.77 275.632 2330.77 379.901C2330.77 470 2400.45 510.495
    2489.31 510.495C2563.02 510.495 2617.55 479.111 2645.82
    441.655C2655.92 489.236 2684.19 510.495 2731.65 510.495C2777.86
    510.495 2815.45 496.103 2850.03 471.043C2851.7 469.834 2852.41
    467.653 2851.77 465.686ZM2638.75 386.992C2622.6 418.376 2590.29
    444.693 2549.89 444.693C2508.49 444.693 2480.22 420.395 2480.22
    367.756C2480.22 301.954 2522.63 259.435 2638.75
    260.45V386.992ZM2322.22 466.676C2275.07 456.437 2266.44 438.373
    2266.44 371.304V168.831C2266.44 51.3994 2209.9 0.784557 2119.02
    0.784557C2052.37 0.784557 1997.85 34.1928 1950.38 84.8124C1929.18
    25.0823 1881.72 0.784557 1816.09 0.784557C1755.7 0.784557 1706.45
    28.2351 1669.07 64.9484V19.0674C1669.07 5.87081 1656.02 -3.3254
    1643.63 1.14174L1473.98 76.4306C1472.26 77.1926 1471.16 78.9023
    1471.16 80.7882V106.267C1471.16 108.501 1472.74 110.396 1474.91
    110.896C1522.1 121.854 1530.73 153.158 1530.73
    153.158V264.031C1464.98 358.055 1406.98 437.107 1272.64
    437.107C1176.71 437.107 1110.06 408.994 1105.02 284.471L1437.56
    252.401C1445.05 251.678 1450.68 245.21 1450.46 237.667C1445.78
    78.6832 1357.5 0.779794 1214.07 0.779794C1050.48 0.779794 955.566
    122.259 955.566 258.926C955.566 403.689 1050.48 511 1225.18
    511C1297.1 511 1372.71 484.859 1428.76 437.173C1528.21 352.56
    1579.56 236.19 1659.57 138.456C1680.78 110.11 1716.12 80.7548
    1759.54 80.7548C1802.96 80.7548 1824.16 108.086 1824.16
    168.826V371.3C1824.16 438.345 1815.54 456.418 1769.38
    466.662C1767.19 467.148 1765.6 469.067 1765.6
    471.315V495.103C1765.6 497.732 1767.72 499.865 1770.35
    499.865H2017.33C2019.95 499.865 2022.08 497.732 2022.08
    495.103V471.329C2022.08 469.077 2020.48 467.153 2018.28
    466.672C1971.13 456.432 1962.5 438.369 1962.5 371.3V168.826C1962.5
    158.706 1962.5 149.595 1961.49 140.48C1982.7 111.125 2019.05 80.7548
    2062.47 80.7548C2106.9 80.7548 2128.1 108.086 2128.1
    168.826V371.3C2128.1 438.369 2119.48 456.432 2072.33 466.672C2070.14
    467.153 2068.53 469.077 2068.53 471.329V495.103C2068.53 497.732
    2070.66 499.865 2073.28 499.865H2321.27C2323.89 499.865 2326.02
    497.732 2326.02 495.103V471.329C2326.02 469.077 2324.42 467.157
    2322.22 466.676ZM1204.57 48.3562C1290.83 38.2885 1318.19 124.445
    1318.19 205.987L1106.02 229.799C1112.08 148.81 1119.97 58.2334
    1204.57 48.3562ZM429.154 91.856C429.154 138.423 401.892 173.86
    359.481 173.86C322.12 173.86 307.983 153.61 297.884 133.365C290.815
    116.154 283.747 99.9569 258.503 99.9569C236.286 99.9569 216.092
    115.139 197.913 147.533V371.295C197.913 438.521 207.547 456.509
    260.66 466.743C262.907 467.176 264.56 469.129 264.56
    471.42V495.103C264.56 497.732 262.437 499.865 259.81
    499.865H4.75033C2.12815 499.865 0 497.732 0 495.103V471.329C0
    469.077 1.60561 467.153 3.80026 466.672C50.9473 456.432 59.5739
    438.369 59.5739 371.295V154.053C59.5739 154.053 50.9425 122.75
    3.75751 111.791C1.58186 111.296 0 109.396 0 107.167V81.693C0
    79.8071 1.11158 78.0974 2.83119 77.3354L175.344 1.01315C186.137
    -2.88249 197.433 5.40885 196.996 16.9005L194.887 90.8511C226.187
    46.3036 286.777 0.75122 342.318 0.75122C401.892 0.75122 429.154
    42.2508 429.154 91.856ZM682.907 0.779794C519.32 0.779794 424.404
    122.259 424.404 258.926C424.404 403.689 519.32 511 694.018
    511C812.805 511 880.055 456.456 911.536 419.009C913.06 417.195
    912.965 414.537 911.379 412.78L888.059 386.982C886.297 385.03
    883.319 384.901 881.361 386.658C852.213 412.804 810.363 437.102
    741.474 437.102C645.546 437.102 578.899 408.989 573.854
    284.467L906.396 252.392C913.892 251.668 919.521 245.205 919.298
    237.662C914.623 78.6832 826.343 0.779794 682.907 0.779794ZM574.861
    229.799C580.918 148.81 588.803 58.2334 673.406 48.3562C759.663
    38.2885 787.029 124.445 787.029 205.987L574.861 229.799ZM1728.64
    471.329V495.103C1728.64 497.732 1726.52 499.865 1723.89
    499.865H1475.9C1473.28 499.865 1471.15 497.732 1471.15
    495.103V471.329C1471.15 469.077 1472.76 467.153 1474.95
    466.672C1522.1 456.428 1530.73 428.92 1530.73
    390.511V389.001C1530.73 383.739 1535.65 379.491 1538.67
    375.652C1577.01 327.443 1609.01 274.561 1643.87 223.865C1648.54
    217.069 1658.32 215.212 1664.45 220.717C1667.22 223.213 1669.07
    226.846 1669.07 231.275V371.29C1669.07 438.364 1677.7 456.423
    1724.85 466.667C1727.04 467.143 1728.65 469.072 1728.65
    471.324L1728.64 471.329Z`;
